<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SewLJp/tc-custom/9781590209417.jpg?1706124137883" alt="This image is the cover for the book Envy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Envy
      </h1>
      <p class="bookDescription body article font2">
        <b>“To read [this] triumphant short novel is . . . to behold man’s heroic confrontation with the monsters of his own creation.” —<i>The New York Times</i></b><br/><br/> Andrei Babichev is a paragon of Soviet values, an innovative and practical man, Director of the Food Industry Trust, a man whose vision encompasses such future advances for mankind as the 35-kopeck sausage and the self-peeling potato. Out of kindness, he rescues from the gutter Nikolai Karalerov, violently tossed from a bar after a drunken and self-destructive tirade. But instead of gratitude, Babichev finds himself the subject of an endlessly malignant jealousy, as Kavaelrov sees in him a representative of the new breed of man who has prevented him from realizing his true greatness.<br/><br/> A scathing social satire, <i>Envy </i>is a concise and incisive exploration of the paradigmatic conflicts of the early Soviet age: old versus new, imagination versus pragmatism, and the alienation of the romantic artist in the age of technology. One of the signs of the book’s universality is the fact that it has been claimed by nearly every school of critics and interpreted as everything from a submerged homosexual story to a twentieth-century <i>Notes from the Underground</i>.<br/><br/> “Poetic and satiric and quite an achievement, it is a novel everyone should read.” —<i>Flavorwire</i><br/><br/> “Vladimir Nabokov had a low opinion of almost everything produced in Russia after his departure, but he admired Olesha’s writing.” —<i>Columbus Dispatch</i><br/><br/> “Olesha writes about the clash of two worlds, but with a wry, half-defeated yet touchingly affectionate irony that seems entirely his own.” —Irving Howe, <i>Harper’s</i> magazine 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yury Olesha, T. S. Berczynski
      </h2>
      
      <p class="authorDescription body article">Yuri Olesha (1899–1960), the son of an impoverished land-owner who spent his days playing cards, grew up in Odessa, a lively multicultural city whose literary scene also included Isaac Babel. Olesha made his name as a writer with Three Fat Men, a proletarian fairy tale, and had an even greater success with Envyin 1927. Soon, however, the ambiguous nature of the novella’s depiction of the new revolutionary era led to complaints from high, followed by the collapse of his career and the disappearance of his books. In 1934, Olesha addressed the First Congress of Soviet Writers, arguing that a writer should be allowed the freedom to choose his own style and themes. For the rest of his life he wrote very little. A memoir of his youth, No Day Without a Line, appeared posthumously.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30a6eb1e